<div class="add-70">
    <div class="full-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
            <h2 class="font-600 text-center">
                Implementing the Impossible is Simply Possible
            </h2>
        </div>
        <div class="down-arrow">
            <img src="assets/img/drop_down.svg" alt="">
        </div>
    </div>
</div>

<div class="page-section" id="">
    <div class="container">
        <!-- Loop through all USPs -->
        <ng-container *ngFor="let usp of usps; let i = index">
            <ng-container *ngIf="i % 2 == 0">
                <div class="row align-items-center flex-wrap h-100 usp-row">
                    <div class="col-md-7 col-12">
                        <h3 class="font-700 h2-text">{{usp.header}}</h3>
                        <p class="mb-4">{{usp.sub_header}}</p>
                        <button type="button" class="btn brand-button" routerLink="/product/journey">{{usp.button}}</button>
                    </div>
                    <div class="col-md-5 col-12 mobile-usp-image">
                        <img [src]="usp.img" [alt]="usp.alt" class="usp-image usp-right">
                    </div>
                </div>
                <div style="display: grid" *ngIf="i < usps.length-1">
                    <div class="divider"></div>
                </div>
            </ng-container>
            <!-- Flip on odd items -->
            <ng-container *ngIf="i % 2 == 1">
                <div class="row align-items-center flex-wrap h-100 usp-row odd-col">
                    <div class="col-md-5 col-12 mobile-usp-image">
                        <img [src]="usp.img" [alt]="usp.alt" class="usp-image">
                    </div>
                    <div class="col-md-7 col-12 move-right">
                        <h3 class="font-700">{{usp.header}}</h3>
                        <p class="mb-3">{{usp.sub_header}}</p>
                        <button type="button" class="btn brand-button" routerLink="/product/journey">{{usp.button}}</button>
                    </div>
                </div>
                <div style="display: grid" *ngIf="i < usps.length-1">
                    <div class="divider"></div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>

<app-infrastructure-banner></app-infrastructure-banner>